import Vue from 'vue';
// import AreaCodeHolder from '@/common/areaCodeHolder.js';
export default {
  // 采购项目列表
  getPurchaseList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/purchase/purchaseList', params);
  },

  getProjectList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/project/selectTradePro', params);
  },
  // 交易项目--附近项目
  getselectNearbyTradePro (params) {
    return Vue.axios.post('/api/v1.0/chanquan/project/selectNearbyTradePro', params);
  },
  // 采购项目--附近项目
  getnearByPurchaseList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/purchase/nearByPurchaseList', params);
  },

  getProjectStatusList () {
    return Vue.axios.get('/api/v1.0/chanquan/project/projectListStatus?type=projectStatus');
  },
  getPurchaseStatusList () {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/purchaseListStatus?type=purchaseStatus');
  },
  // 获取推荐项目
  getRecommendProject (limitNum) {
    // const length = AreaCodeHolder.getInstance().areaCode.length;
    let params = { limitNum };
    // if (length === 4) {
    //   params = {
    //     limitNum,
    //     county: AreaCodeHolder.getInstance().areaCode
    //   };
    // } else if (length === 6) {
    //   params = {
    //     limitNum,
    //     township: AreaCodeHolder.getInstance().areaCode
    //   };
    // } else 
    if (length === 2) {
      params = {
        limitNum: 4
        // city: AreaCodeHolder.getInstance().areaCode
      };
    }
    return Vue.axios.post('/api/v1.0/chanquan/project/selectIndexRecommendProject', params);
  },
  // 获取推荐项目
  indexShowProjectInfo () {
    return Vue.axios.get('/api/v1.0/chanquan/project/indexShowProjectInfo');
  },
  // 首页统计信息
  showProjectInfo (keys, val) {
    return Vue.axios.get('/api/v1.0/chanquan/project/showProjectInfo?' + keys + '=' + val);
  },
  //  获取项目子类型
  getProjectSubType (projectType) {
    return Vue.axios.get('/api/v1.0/chanquan/project/getProjectSubType/' + projectType);
  },
  // 竞价大厅列表
  getBidselectList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/project/selectBidList', params);
  },
  // 获取竞价大厅所有数据
  getBidAlllist (params) {
    return Vue.axios.post('/api/v1.0/chanquan/project/selectAllBidList', params);
  },
  // 查询资讯列表
  getNewsList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/news/selectNewsListByPage', params);
  },
  // 获取账户信息
  getUserBaseInfo () {
    return Vue.axios.get('/api/v1.0/chanquan/user/getUserBaseInfo');
  },
  // 获取banner
  appAdvertList () {
    return Vue.axios.get('/api/v1.0/chanquan/advert/appAdvertList?type=2');
  },
  getLinkManagementList (params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/link/management/list', { params });
  }
};
